export default {
	"Testing":"Тестирование",
	"Management":"Менеджмент",
	"Support":"Поддержка",
	"Data Quality":"Качество данных",
	"No new notifications":"Нет новых уведомлений",
	"Team Progress":"Прогресс команды",
	"Add a task":"Добавить задачу",
	"Click to search a task":"Найти задачу",
	"Open the list of all tasks":"Открыть список всех задач",
	"View the latest notifications":"Просмотреть список последних уведомлений",
	"Change your personal settings":"Cambia tu configuración personal",
	"Pick your side of the Force":"Выберите сторону Силы",
	"Dark":"Темная",
	"Light":"Светлая",
	"Pick a language":"Выберите язык",
	"Latest tasks in your projects":"Новые задачи на ваших проектах",
	"Top margin in a popup window is smaller than the...":"Верхнее поле во всплывающем окне меньше чем...",
	"Autocat report":"Очет по Autocat",
	"Navigations problem in the left menu":"Проблемы с навигацией в левом меню",
	"Assignment":"Поручение",
	"Gita Noda assigned you a new ticket":"Gita Noda назначила вам новое задание",
	"Lorena Rush added new tasks":"Lorena Rush добавила новые задачи",
	"'Confirm' button styling":"Стилизация кнопки 'OK'",
	"Cubebeat report":"Отчет по Cubebeat",
	"No ability to exit profile editing dialogue":"Невозможно выйти из редактирования профиля",
	"See all notifications":"Посмотреть все уведомления",
	"Persons":"Сотрудники",
	"Click to sort":"Сортировать",
	"Total tasks completed":"Завершенные задачи",
	"Hours spent, %":"Распределение рабочего времени,%",
	"Individual employee's progress":"Прогресс сотрудника",
	"Total tasks by projects":"Всего задач по каждому проекту",
	"incomplete":"незавершено",
	"Tasks":"Задачи",
	"Meeting":"Митинги",
	"Mail":"Почта",
	"Calls":"Звонки",
	"Button text on mobile devices":"Текст на кнопке на мобильных устройствах",
	"Search pattern is ambiguous":"Неясный алгоритм поиска",
	"Links in the upper right menu":"Ссылки в верхнем правом меню",
	"Menu thumbnails disappear when I click them":"Иконки меню исчезают, когда я по ним кликаю",
	"Document export is empty":"Экпортируемый документ пуст",
	"Button text in the right menu":"Текст на кнопке в правом меню",
	"Search is not working properly":"Поиск неправильно работает",
	"How do I define which column the sort was activated from?":"Как определить, из какой колонки запущена сортировка?",
	"How to apply fewer options of drop down menu for specific rows of datatable?":"Как создавать контекстные меню с разным количеством опций для разных строк таблицы?",
	"Prevent clearing CSS added to node after filterByAll() in datatable filter":"Не допускать удаления CSS для элемента после фильтра в таблице с помощью filterByAll()",
	"Can each series in a line chart have its own dataCollection?":"Может ли у каждой серии в линейном чарте быть своя дата коллекция?",
	"Labels in rangechart":"Текстовые ярлыки у rangechart",
	"onBlur event not working for MultiSelect":"событие onBlur не работает с MultiSelect",
	"Datatable focus on first cell":"Фокус на первой ячейке в Datatable",
	"Binding Filters to each other":"Связывание фильтров",
	"Error: [DOM] Found 7 elements with non-unique id":"Ошибка: [DOM] Найдены 7 элементов с неуникальными ID",
	"Datatable editing within multiview":"Редактирование данных в Datatable внутри multiview",
	"Dynamic load filtering doesnot work with custom request call to server":"Фильтрация при динамической загрузке не работает с произвольным обращением к серверу",
	"Task":"Задача",
	"Project":"Проект",
	"User":"Сотрудник",
	"Start":"Начало",
	"Completed":"Конец",
	"Add a new task":"Добавить задачу",
	"Assignee":"Сотрудник",
	"Cancel":"Отменить",
	"Add":"Добавить",
	"Click to complete/uncomplete the task":"Кликните, чтобы завершить или снова открыть задачу",
	"Double-click to edit the task name":"Кликните два раза, чтобы изменить название задачи",
	"Double-click to change the project":"Кликните два раза, чтобы переместить задачу в другой проект",
	"Double-click to assign to a different employee":"Кликните два раза, чтобы поручить задачу другому сотруднику",
	"The task was created":"Задача создана",
	"The task was completed":"Задача выполнена",
	"Click on the red clock to complete the task":"Кликните на красные часы слева, чтобы закрыть задачу",
	"Week":"Неделя",
	"tasks completed":"заданий выполнено",
	"Go back to the dashboard":"Вернуться к дашборду",
	"Ain't it amazing?":"Ну прелесть же!",
	"Meaning the view from your window. Even if it's too urban or too industrial to your taste, you can find curious beauty in its geometry.":"Выгляните в окно. Даже если вид из него слишком городской или промышленный, вы без труда сможете рассмотреть затейливую красоту его геометрии.",
	"Components":"Компоненты",
	"Can you name all the Webix components that have been used to build the demo app?":"А вы сможете назвать все виджеты, из которых построена эта демка?",
	"We miss you":"Мы скучаем по вам",
	"Been pretty busy lately, haven't you? That's great! But also do not forget about us.":"Занятая выдалась неделька? Так держать! Но и о нас тоже не забывайте.",
	"Have a nice day":"Хорошего вам дня",
	"Dear client, whenever you are reading this, we wish you a merry day. May luck and success attend you.":"Дорогие клиенты, если вы читаете это, значит мы желаем вам веселого дня. И да пребудут с вами удача и успех.",
	"Colors and Languages":"Цвета и языки",
	"To pick a language or the color theme for the demo app, click on the avatar in the top right corner.":"Чтобы изменить цвета и язык демки, кликните по картинке в верхнем правом углу.",
	"We love you":"Мы вас любим",
	"Dear client, we love you very much. If our feelings are mutual, contact us and download Webix. Then we will love you eternally.":"Дорогие клиенты, вы вас очень любим. Если наши чувства взаимны, напишите нам и скачайте Webix. Тогда мы будем любить вас вечно."
};